import { render } from "./TanpaBilManualTarikh.vue?vue&type=template&id=da92fe26"
import script from "./TanpaBilManualTarikh.vue?vue&type=script&lang=js"
export * from "./TanpaBilManualTarikh.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__